<template lang="pug">
  section
    .buttons.are-small
      button(class="button is-small" @click="openDeliveredPage()")
        | 出荷管理IDリスト
      button(
        class="button is-small"
        v-for="deliver_type in listing_deliver_types"
        :key="deliver_type"
        @click="setDeliverType(deliver_type)"
        :disabled="linkDisabled(deliver_type)"
      )
        | {{ deliver_type }}

    .scroll-table.table-border
      b-table(
        :data="data" :loading="loading"
        )
        template(slot-scope="props")
          b-table-column(field="did" label="出荷管理ID")
            b-field {{ props.row.did }}
          b-table-column(field="deliver_type_id" label="出荷属性")
            b-field {{ deliverTypeName(props.row.deliver_type_id) }}
          b-table-column(field="delivered_number" label="出荷総数")
            b-field {{ props.row.manipulated_number }} 冊
          b-table-column(field="user_id" label="処理実行者")
            b-field {{ userName(props.row.user_id) }}
          b-table-column(field="revert" label="出荷指示を戻す")
            b-field
              a(@click="cancel(props.row.id, props.row.deliver_type_id, $event)" data-turbolinks='false' v-if="props.row.downloaded_at" :id="'cancel-link' + props.row.id")
                | 戻す
          b-table-column(field="revert" label="ダウンロード")
            b-field
              a(@click="download(props.row.id, props.row.deliver_type_id, $event)" data-turbolinks='false' v-if="!props.row.downloaded_at" :id="'download-link' + props.row.id")
                | DL
              span(v-else) 処理済み
          b-table-column(field="delete" label="削除")
            span(@click="deleteDeliveredOrder(props.row)" :id="'delete-link' + props.row.id" v-if="!props.row.downloaded_at")
              b-icon(pack="fas" custom-class="fa-trash-alt")

</template>

<script>

export default {
  name: "delivered-orders-table",
  data() {
    return {
      data: [],
      manipulated_orders: [],
      total: 0,
      loading: false,
      sortField: 'vote_count',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      perPage: 25,
      isComponentModalActive: false,
      formProps: {
        shop_code_cont: '',
        name_cont: '',
        group_code_cont: '',
        telephone_cont: '',
        prefecture_cont: '',
        s: ''
      },
      default_params: null,
      listing_deliver_types: [
        "大村在庫", "日販在庫", "トーハン在庫", "京北在庫", "文響社在庫", "印刷所在庫", "直送(大村)", "直送(文響社)", "直送(京北)"
      ]
    }
  },
  props: {
  },
  // components: { 'search-modal-form': SearchModalForm },
  computed: {
    agencies(){ return this.$store.getters['Agencies/records'] },
    books(){  return this.$store.getters['Books/records'] },
    deliver_types(){  return this.$store.getters['DeliverTypes/records'] },
    accepting_order_routes(){  return this.$store.getters['AcceptingOrderRoutes/records'] },
    users(){ return this.$store.getters['Users/records'] },
  },
  methods: {
    download(id, deliver_type_id, event){
      event.currentTarget.style.visibility = 'hidden' // 複数回押されるのを防ぐ
      let link = this.createLink(id, deliver_type_id, false)
      link.click()
      location.href = '/users/delivered_orders'
    },
    cancel(id, deliver_type_id, event) {
      event.currentTarget.style.visibility = 'hidden' // 複数回押されるのを防ぐ
      let link = this.createLink(id, deliver_type_id, true)
      if(confirm('本当に出荷指示を戻してもよろしいですか？')) {
        link.click()
      }
    },
    createLink(id, deliver_type_id, canceling) {
      const extension = this.downloadExtension(deliver_type_id)
      let link = document.createElement('a')
      let url =  `/users/delivered_orders/${id}${extension}?canceling=${canceling}`
      if(!canceling) {
        url += '&mode=export'
        link.download = true
      }
      link.href = url
      return link
    },
    downloadExtension(deliver_type_id) {
      const deliverTypeName = this.deliverTypeName(deliver_type_id)
      switch (this.deliverTypeName(deliver_type_id)) {
        case '大村在庫', "印刷所在庫", "京北在庫", "文響社在庫":
          return ''
          break
        case 'トーハン在庫':
          return '.pdf'
          break
        case '日販在庫':
          return '.xls'
          break
        default:
          return ''
          break;
      }
    },
    openNew(){
    },
    /*
     * Load async data
     */
    openDeliveredPage(){
      window.location.href = `/users/delivered_orders`
    },
    deleteDeliveredOrder(delivered_order) {
      this.$dialog.confirm({
        title: '以下の出荷管理を削除してもよろしいですか?',
        message: `出荷管理ID: ${delivered_order.did}`,
        onConfirm: () => {
          this.loading = true
          this.$http.delete(`/api/v1/delivered_orders/${delivered_order.id}.json`).then((result) => {
            this.loadAsyncData()
            this.loading = false
            this.$toast.open({
              message: '出荷指示を削除しました。',
              type: 'is-danger',
              position: 'is-bottom'
            })
          })
          .catch((error) => {
            this.loading = false
            this.$toast.open({
              message: '削除に失敗しました。しばらくしてからもう一度お試しください。',
              type: 'is-danger',
              position: 'is-bottom'
            })
            throw error
          })
        }
      })
    },
    setDeliverType(deliver_type_name){
      const id = this.deliverTypeId(deliver_type_name)
      if (id)
        window.location.href = `/users/delivered_orders/new?deliver_type_id=${id}`
    },
    linkDisabled(deliver_type_name) {
      const id = this.deliverTypeId(deliver_type_name)
      if(!id) return true

      const manipulated_orders = this.manipulated_orders.filter(order => order.deliver_type_id == id)
      if(manipulated_orders.length > 0)
        return false

      return true
    },
    async submit(){
      var method = 'post'
      var url = `/api/v1/delivered_orders.json`
      var manipulated_order_ids = this.data.filter(item => item.checkbox == "true").map((item) =>{
        return item.id
      })
      var params = {
        delivered_order: {
          manipulated_order_ids: manipulated_order_ids
        }
      }
      this.loading = true
      this.error_message = null
      try{
        const res = await this.$http({ method: method, url: url, data: params })
        const data = res.data
        this.loading = false
        window.location.href = `/users/delivered_orders`
      }catch (error) {
        const {
          status,
          statusText,
          data
        } = error.response;
        this.loading = false
        this.error_message = data.messages.map((msg) => { return msg.message }).join(",")
        throw error
      }
    },
    onClickDownload(id){

    },
    disabledSubmitButton(){
      var result = true
      this.data.forEach((item) => {
        if(item.checkbox == 'true') {
          result = false
        }
      })
      console.log(result)
      return result
    },
    agencyName(agency_code){
      if (!agency_code) return ''
      let tmp = this.agencies
          .filter(agency => agency.code == agency_code)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    bookName(value){
      let a = this.getBook(value)
      return a != null ? `${a.name}: ${a.isbn}` : ''
    },
    bookAuthor(value){
      let a = this.getBook(value)
      return a != null ? `${a.author}` : ''
    },
    bookReleasedOn(value){
      let a = this.getBook(value)
      return a != null ? `${a.released_on}` : ''
    },
    bookSellingPrice(value){
      let a = this.getBook(value)
      return a != null ? `${a.selling_price}` : ''
    },
    getBook(value){
      if (!value) return null
      let a = this.books.filter(book => book.isbn == value || book.id == value)
      return a.length > 0 ? a[0] : null
    },
    orderRouteName(id){
      if (!id) return ''
      let tmp = this.accepting_order_routes
          .filter(route => route.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    deliverTypeName(id){
      if (!id) return ''
      let tmp = this.deliver_types
          .filter(type => type.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    deliverTypeId(deliver_type_name) {
      if(!deliver_type_name) return ''
      let tmp = this.deliver_types.filter(type => type.name == deliver_type_name)
      if(tmp.length == 0)
       return ''
      return tmp[0].id
    },
    userName(id){
      if (!id) return ''
      let tmp = this.users
          .filter(user => user.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    loadAsyncData() {
      this.loading = true
      this.$http.get(`/api/v1/delivered_orders`)
          .then(({data}) => {
            this.data = []
            data.delivered_orders.forEach((item) => {
              this.data.push(Object.assign({}, item))
            })
          })
          .catch((error) => {
            this.data = []
            this.total = 0
            this.loading = false
            throw error
          })
      this.$http.get(`/api/v1/manipulated_orders?q[delivered_order_id_null]=1&per_page=999999`)
          .then(({data}) => {
            this.manipulated_orders = []
            data.manipulated_orders.forEach((item) => {
              if(item.total_order_number > 0) {
                this.manipulated_orders.push(Object.assign({}, item))
              }
            })
            this.loading = false
          })
          .catch((error) => {
            this.data = []
            this.total = 0
            this.loading = false
            throw error
          })
    },
  },
  filters: {
    /**
     * Filter to truncate string, accepts a length parameter
     */
    truncate(value, length) {
      return value.length > length
          ? value.substr(0, length) + '...'
          : value
    }
  },
  created(){
    this.default_params = '?' + [
      `page=${this.page}`,
      Object.keys(this.formProps).map((key) => {
        return `q[${key}]=${this.formProps[key]}`
      }).join('&')
    ].join('&')

    this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
    this.$store.dispatch('Users/fetch', 'users')
  },
  mounted() {
    this.loadAsyncData()
  }
}

</script>
